import * as React from 'react';
import { LmBasicRouteProps } from 'src/utils/routerSupportTypes';
import LoginContainer from '../containers/Login';

/**
 * ログイン画面
 * @param props
 */
const Login: React.FC<LmBasicRouteProps> = props => {
	return <LoginContainer {...props} />;
};

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.tsx